import { CREATE_MAIL_TEMPLATE, GET_MAIL_TEMPLATE, MAIL_TEMPLATE_REQUEST, DELETE_MAIL_TEMPLATE, UPDATE_MAIL_TEMPLATE, MAIL_TEMPLATE_REQUEST_FAILURE, GET_MAIL_TEMPLATE_MODULE, GET_MAIL_TEMPLATE_REQUEST_SUCCESS } from "../types";

const initialState = {
  mailTemplateModules: [],
  mailTemplate: [],
  loading: false,
  error: null,
};

const mailTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case MAIL_TEMPLATE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_MAIL_TEMPLATE_MODULE: {
      return {
        ...state,
        mailTemplateModules: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_MAIL_TEMPLATE:
      return {
        ...state,
        mailTemplate: [action.payload, ...state.mailTemplate],
        loading: false,
        error: null
      };

    case UPDATE_MAIL_TEMPLATE:
      const mailTemplateData = state.mailTemplate.slice(0);
      const uIndex = mailTemplateData.findIndex((data) => data.id === action.payload.id);
      mailTemplateData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        mailTemplate: [ ...mailTemplateData ],
        loading: false,
        error: null
      };

    case DELETE_MAIL_TEMPLATE:
      const templates = state.mailTemplate?.slice(0);
      const index = templates.findIndex((data) => data.id === action.id);
      if (index > -1) {
          templates.splice(index, 1);
      }
      return {
        ...state,
        mailTemplate: [...templates],
        loading: false,
        error: null
      }
    case MAIL_TEMPLATE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case GET_MAIL_TEMPLATE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    default:
      return state;
  }
};

export default mailTemplateReducer;